import { ActionType, EntityType, ModuleType } from "../../queryKeyFactory";

export const nscKeyFactory = {
    list: (params?: any): [EntityType, ActionType, any?] => [
      "nsc",
      "list",
      params,
    ],
    consumerDetails: (params: {
      remote_utility_id: string;
      consumer_id: string;
      is_detail_info: boolean;
    }): [EntityType, "consumerDetails", any] => [
      "nsc",
      "consumerDetails",
      params,
    ],
    plan: (params: {
      remoteUtilityId: string;
    }): [EntityType, "plan", any] => [
      "nsc",
      "plan",
      params,
    ],
    consumerAddress: (params: {
      remote_utility_id: any;
      consumer_id: string;
      is_address_info: any;
    }): [EntityType, "consumerAddress", any] => [
      "nsc",
      "consumerAddress",
      params,
    ],
    kycInfo: (params: {
      remote_utility_id: any;
      consumer_id: string;
      is_kyc_info: any;
    }): [EntityType, "kycInfo", any] => ["nsc", "kycInfo", params],
    emailVerify: (params: {
      email: string;
    }): [EntityType, "emailVerify", any] => ["nsc", "emailVerify", params],
    paymentMode: (params: {
      remote_utility_id: any;
    }): [EntityType, "paymentMode", any] => ["nsc", "paymentMode", params],
    planInfo: (params: {
      remote_utility_id: any;
      consumer_id: string;
      is_plan_info: any;
    }): [EntityType, "planInfo", any] => ["nsc", "planInfo", params],
    category: (params: {
      remote_utility_id: any;
      config_level: string;
    }): [EntityType, "category", any] => ["nsc", "category", params],
    subCategory: (params: {
      remote_utility_id: any;
      config_level: string;
      code_list: string;
    }): [EntityType, "subcategory", any] => ["nsc", "subcategory", params],
    premise: (params: {
      remote_utility_id: any;
      config_level: string;
    }): [EntityType, "premise", any] => ["nsc", "premise", params],
    addressInfo: (params: {
      remote_utility_id: any;
      premise: string;
    }): [EntityType, "addressInfo", any] => ["nsc", "addressInfo", params],
    consumerRelation: (): [EntityType, "consumerRelation"] => [
      "nsc",
      "consumerRelation",
    ],
    documentType: (params: {
      remote_utility_id: string;
      config_level: string;
    }): [EntityType, "documentType", any] => [
      "nsc",
      "documentType",
      params,
    ],
    documentSubType: (params: {
      remote_utility_id: string;
      config_level: string;
      code_list: string;
    }): [EntityType, "documentSubType", any] => [
      "nsc",
      "documentSubType",
      params,
    ],
    searchPlan: (params: {
      remoteUtilityId: string;
      searchField: string;
      searchData: string;
    }): [EntityType, "searchPlan", any] => ["nsc", "searchPlan", params],
  };